module.exports = __webpack_public_path__ + "img/settings-2_960.88df64b9.jpg";